import React from "react";
import Select, { SelectProps, transformDataToSelectOption } from "@/components/atoms/Select";
import { useGetLanguages } from "@/services/RegisterCompany";
import { useTranslation } from "react-i18next";

type keyOptions = "id" | "name" | "languageCode";

interface SelectPropsExtended extends SelectProps {
  valueKey: keyOptions;
  labelKey: keyOptions;
}

const SelectLanguage: React.FC<SelectPropsExtended> = ({ valueKey, labelKey, ...restProps }) => {
  const { data: languageOptions, isLoading } = useGetLanguages();
  const { t } = useTranslation();

  const options = transformDataToSelectOption(
    languageOptions || [],
    valueKey || "id",
    labelKey || "languageCode",
    t,
    "enumerables:languages"
  );
  return <Select data={options} loading={isLoading} {...restProps} />;
};
export default SelectLanguage;
